// tslint:disable-next-line:no-namespace
namespace O1X {

    import ptime = HA.ptime;

    export function init(func) {
        new O1XWebPage({jsNotification: func});
    }

    class O1XWebPage extends HA.HAObject {
        protected initialize(data) {
            super.initialize(data);
            this.addToData("horApp", new HA.Core.Service.HorApp(data));
        }

        private preventUnload() {
            window.addEventListener("beforeunload", (event: BeforeUnloadEvent) => {
                // Cancel the event as stated by the standard.
                event.preventDefault();
                // Older browsers supported custom message
                event.returnValue = "";
            });
        }
    }
}
